import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  Table,
  Input,
  Modal,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation"; // Import AvField
import BootstrapTable from "react-bootstrap-table-next";

import { container } from "../../store/Containers/cntCommon";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Fn_DisplayData,
  Fn_AddEditData,
  Fn_FillListData,
} from "../../store/functions";
import { compose } from "recompose";
import { API_WEB_URLS } from "constants/constAPI";
import Select from "react-select";
import PageAddEdit_FundrequestN from "./pageAddEdit_FundrequestN";

class AddEdit_ChargesEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      modal: false,
      selectedId: null,
      charges: "",
      RemainingAmt : 0,
      PaymentMode: [
        { Id: 1, Name: "Cash" },
        { Id: 2, Name: "Online (Not Available)" },
        { Id: 3, Name: "Refund Against Rseva" },
        { Id: 4, Name: "Credit" },
        { Id: 5, Name: "Advance" },
        { Id: 6, Name: "UPI+Cash" }

      ],
      denominations: [
        { Denomination: 500, Quantity: 0 },
        { Denomination: 200, Quantity: 0 },
        { Denomination: 100, Quantity: 0 },
        { Denomination: 50, Quantity: 0 },
        { Denomination: 20, Quantity: 0 },
        { Denomination: 10, Quantity: 0 },
        { Denomination: 1, Quantity: 0 },
      ],
      denominationsRe: [
        { Denomination: 500, Quantity: 0 },
        { Denomination: 200, Quantity: 0 },
        { Denomination: 100, Quantity: 0 },
        { Denomination: 50, Quantity: 0 },
        { Denomination: 20, Quantity: 0 },
        { Denomination: 10, Quantity: 0 },
        { Denomination: 1, Quantity: 0 },
      ],
      F_LedgerMasterCr:0,
      selectedPaymentMode: null, // State for selected payment mode
      gridData: [], // Initialize gridData
      showDenomination: false, // Show Denomination when "Cash" is selected
      isRe: false, // State for IsRe checkbox
      F_AdvanceId : 0,
      UPIAmount : 0
    };

    this.obj = this;
    this.formTitle = "Charges Entry";
    this.breadCrumbTitle = "Transactions";
    this.breadCrumbItem = "Add/Edit Charges Entry";
    this.pushFormName  =  '#';

    // Event Binding
    this.btnSave_onClick = this.btnSave_onClick.bind(this);
    this.btnGoBack_onClick = this.btnGoBack_onClick.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.calculateTotalAmount = this.calculateTotalAmount.bind(this);
    this.handlePaymentModeChange = this.handlePaymentModeChange.bind(this);
    this.handleDenominationReChange = this.handleDenominationReChange.bind(this);
    this.btnAdd_Ledger =  this.btnAdd_Ledger.bind(this);
    this.fundmodal  = this.fundmodal.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    
  }

  toggleRightCanvas() {
    this.setState({
      isRight: !this.state.isRight,
      F_BankMaster: -1,
      selectedGroup: {},
      IFSC: "",
      AccountHolderName: "",
      AccountNo: "",
    });
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const obj = JSON.parse(sessionStorage.getItem("authUser"));
    this.setState({
      name: obj.username,
      email: obj.email,
      aid: obj.uid,
      role: obj.role,
      UserId : obj.UserId
    });
        Fn_FillListData(
              this.obj,
              "Ledger",
              API_WEB_URLS.MASTER + "/0/token/LedgerForAccounting/Id/0"
            );
            Fn_FillListData(
              this.obj,
              "Advance",
              API_WEB_URLS.MASTER + "/0/token/GetAdvance/Id/0"
            );
    Fn_FillListData(
      this.obj,
      "gridData",
      API_WEB_URLS.MASTER + "/0/token/TopChargeNew/Id/" + id
    );

    Fn_FillListData(
      this.obj,
      "refundeddmr",
      API_WEB_URLS.MASTER + "/0/token/RefundedDMT/Id/0"
    );
   
  }

  handleQuantityChange(event, index) {
    const value = Number(event.target.value);
    const denominations = [...this.state.denominations];
    denominations[index].Quantity = value;
    this.setState({ denominations }, this.calculateTotalAmount );
  }

  calculateTotalAmount() {
    const { denominations } = this.state;
    let total = 0;
    denominations.forEach(({ Denomination, Quantity }) => {
      total += Denomination * Quantity;
    });
    this.setState({ DenominationAmount: total });
  }

  fundmodal() {

  }

  handlePaymentModeChange(event) {
    const selectedMode = event.target.value;
    this.setState({
      selectedPaymentMode: selectedMode,
      showDenomination: selectedMode === "1" ? true : selectedMode === "6" ? true : false, 
      isRe :false
    });
  }

  async btnSave_onClick(event, formData) {
    const { charges, selectedPaymentMode, denominations,gridData, DenominationAmount } = this.state;
    console.log(formData.charges,selectedPaymentMode,denominations,gridData)
    
    if (selectedPaymentMode == 1) { 
      console.log(Number(gridData[0].Amount) + Number(formData.charges))
      if((Number(gridData[0].Amount) + Number(formData.charges) == Number(DenominationAmount))&& !this.state.isRe)
      {
        alert('calculation matched')
      }else if((Number(gridData[0].Amount) + Number(formData.charges) == (Number(DenominationAmount) - Number(this.calculateDenominationReTotal())))&& this.state.isRe) {
        alert('calculation matched')
      }else  {
        var RemainingAmt  =  (Number(gridData[0].Amount) + Number(formData.charges)) - Number(DenominationAmount)
        this.setState({isRe : true, RemainingAmt : RemainingAmt})
        alert('calculation not matched')
        return;
      }
    }


    if (selectedPaymentMode == 6) { 
      console.log(Number(gridData[0].Amount) + Number(formData.charges))
      if((Number(gridData[0].Amount) + Number(formData.charges) == Number(DenominationAmount)  + Number(formData.UpiAmount))&& !this.state.isRe)
      {
        alert('calculation matched')
      }else if((Number(gridData[0].Amount) + Number(formData.charges) == (Number(DenominationAmount) - Number(this.calculateDenominationReTotal()) + Number(formData.UpiAmount)))&& this.state.isRe) {
        alert('calculation matched')
      }else  {
        var RemainingAmt  =  (Number(gridData[0].Amount) + Number(formData.charges)) - Number(DenominationAmount) - Number(formData.UpiAmount)
        this.setState({isRe : true, RemainingAmt : RemainingAmt})
        alert('calculation not matched')
        return;
      }
    }
    

     let vformData1 = new FormData();
   
    vformData1.append("F_VoucherH", gridData[0].F_VoucherH);
    vformData1.append("Charges", formData.charges);
    vformData1.append("Remarks", formData.Remakrs);
    vformData1.append("PaymentMode", selectedPaymentMode );
    vformData1.append("F_LedgerMasterCr", selectedPaymentMode ==4 ? this.state.F_LedgerMasterCr : selectedPaymentMode == 5 ? this.state.F_AdvanceId : selectedPaymentMode == 3 ?  this.state.F_RefundedDMR :selectedPaymentMode == 6 ?  formData.UpiAmount : 0 );

   if(selectedPaymentMode == 1){
    vformData1.append("data", JSON.stringify(this.state.denominations) );
   }

   if(selectedPaymentMode == 1 && this.state.isRe){
    vformData1.append("dataRe", JSON.stringify(this.state.denominationsRe) );
   }

    await Fn_AddEditData(
      this.obj,
      { arguList: { id: 0, formData: vformData1 } },
      "ChargesEntry/0/token",
      this.pushFormName,
      true,
      "Charges"
    );
    //console.log("Data to save: ", saveData);
  }


  btnGoBack_onClick = event => {
    event.preventDefault();
    this.props.history.push("/pendingcharges");
  };
  btnAdd_Ledger = event => {
    event.preventDefault();
    this.props.history.push("/AddLedger");
  };

  // Column configuration
  columns = [
    
    { dataField: "SenderMobileNo", text: "SenderMobileNo", sort: true },
    { dataField: "AccountHolderName", text: "Name", sort: true },
    { dataField: "BankName", text: "BankName", sort: true },
    { dataField: "AccountNo", text: "Account No", sort: true },
    { dataField: "TransactionCode", text: "Transaction Code", sort: true },
    { dataField: "Amount", text: "Amount", sort: true }
    // { dataField: "Charges", text: "Charges", sort: true },
  ];


render() {
    const { gridData, PaymentMode, denominations, showDenomination, selectedPaymentMode, isRe, denominationsRe } = this.state;

    const mapLedgerToSelectOptions = (ledger) =>
      (ledger || []).map(item => ({
        value: item.Id,
        label: item.Name,
      }));
      const ledgerOptions = mapLedgerToSelectOptions(this.state.Ledger);
      const defaultCrAOption = ledgerOptions.find(option => option.value === this.state.F_LedgerMasterCr) || null;
    
      const advanceOptions = mapLedgerToSelectOptions(this.state.Advance);
      const defaultAdvanceAOption = advanceOptions.find(option => option.value === this.state.F_AdvanceId) || null;

      const refundedOptions = mapLedgerToSelectOptions(this.state.refundeddmr);
      const defaultRefundedOption = refundedOptions.find(option => option.value === this.state.F_RefundedDMR) || null;
    
  
    return (
        <React.Fragment>
        <div className="page-content">
          <Container fluid >
            <Breadcrumbs title={this.breadCrumbTitle} breadcrumbItem={this.breadCrumbItem} />
      
            <Row>
              <Col lg="12">
                <Card >
                  <CardBody >
                    <AvForm onValidSubmit={this.btnSave_onClick}>
                      <Row>
                        {/* Left Column: Charges and Payment Mode */}
                        <Col lg="12">
                        <Row>
                            <Col lg="12">
                              <BootstrapTable
                                keyField="Id"
                                data={gridData || []}
                                columns={this.columns}
                                striped
                                hover
                                condensed
                                bordered={true}
                                wrapperClasses="table-responsive table-sm"
                                rowClasses="table-row" // Added rowClasses for better styling
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="1" className="mb-3">
                              <label htmlFor="charges" className="col-form-label">
                                Charges
                              </label>
                            </Col>
                            <Col lg="2">
                              <AvField
                                name="charges"
                                type="number"
                                required
                                placeholder="Enter Charges"
                                errorMessage="Please enter a valid charge amount."
                                className="form-control-sm"
                              />
                            </Col>



                            <Col sm="1" className="mb-3">
                              <label htmlFor="paymentMode" className="col-form-label">
                                Payment Mode
                              </label>
                            </Col>
                            <Col lg="2">
                              <AvField
                                name="paymentMode"
                                type="select"
                                required
                                errorMessage="Please select a payment mode."
                                onChange={this.handlePaymentModeChange}
                                className="form-control-sm"
                              >
                                <option value="">Select Payment Mode</option>
                                {PaymentMode.map(mode => (
                                  <option key={mode.Id} value={mode.Id}>
                                    {mode.Name}
                                  </option>
                                ))}
                              </AvField>
                            </Col>
                            <Col sm="1" className="mb-3">
                              <label htmlFor="charges" className="col-form-label">
                                Remarks
                              </label>
                            </Col>
                            <Col lg="2">
                              <AvField
                                name="Remakrks"
                                type="test"
                                
                                placeholder="Enter Remarks"
                                className="form-control-sm"
                              />
                            </Col>

                             <Col sm="2" className="text-right">
                          <Button type="submit" color="primary" className="btn-sm mr-2">
                            Save
                          </Button>
                          {" "}
                          <Button
                            type="button"
                            color="secondary"
                            className="btn-sm"
                            onClick={this.btnGoBack_onClick}
                          >
                            Go Back
                          </Button>
                        </Col>
                          </Row>
      
                          <Row>
                          


                          {selectedPaymentMode == 1 && (
                            <>
                              <Col sm="2" className="mb-3">
                                <label htmlFor="isRe" className="col-form-label">
                                  IsRe
                                </label>
                              </Col>
                              <Col lg="2">
                                <Input
                                  type="checkbox"
                                  onChange={e => this.setState({ isRe: e.target.checked })}
                                />
                              </Col>




                              </>
                          )}


{this.state.selectedPaymentMode == 6? 
<>
<Row>
                            <Col sm="1" className="mb-3">
                              <label htmlFor="charges" className="col-form-label">
                                UPI Amount
                              </label>
                            </Col>
                            <Col lg="2">
                              <AvField
                                name="UpiAmount"
                                type="number"
                                defaultValue="0"
                                placeholder="Enter UPI Amount"
                                errorMessage="Please enter a valid UPI Amount"
                                className="form-control-sm"
                                onChange={e => this.setState({UPIAmount : e.target.value})}
                              />
                            </Col>


                            <Col>
                            <Button
                            type="button"
                            color="secondary"
                            className="btn-sm"
                            onClick={this.toggleRightCanvas}
                          >
                            Fund Request
                          </Button>
                            </Col>
                            </Row>

</>: null
}


                          
{this.state.selectedPaymentMode == 4?
                          
                          <>
                                                    <Col sm="2" className="mb-3">
                                                        <label htmlFor="paymentMode" className="col-form-label">
                                                          Cr Ledger
                                                        </label>
                                                      </Col>
                          
                                                      <Col lg="2">
                                                    <Select
                                      options={ledgerOptions}
                                      onChange={evnt => this.setState({F_LedgerMasterCr : evnt.value})}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          height: "auto", // Ensure container height adjusts automatically
                                          overflowY: "auto", // Allow vertical scrolling if content overflows
                                          whiteSpace: "normal", // Allow text to wrap
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          whiteSpace: "normal", // Allow text to wrap within single value container
                                          overflow: "hidden", // Hide any overflow
                                          textOverflow: "ellipsis", // Add ellipsis for overflow text
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          position: "absolute",
                                          zIndex: 9999,
                                          top: "100%", // Position below the input field
                                          maxHeight: "200px", // Adjust as needed for maximum height
                                          overflowY: "auto", // Allow vertical scrolling in the dropdown
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      value={defaultCrAOption}
                                      menuPortalTarget={document.body}
                                    />
                          
                                    </Col>
                                    <Col lg="2">
                                    <Button
                            type="button"
                            color="secondary"
                            className="btn-sm"
                            onClick={this.btnAdd_Ledger}
                          >
                            Add ledger
                          </Button>
                          </Col>
                                    </> 
                                                    :null}



{this.state.selectedPaymentMode == 5?
                          
                          <>
                                                    <Col sm="2" className="mb-3">
                                                        <label htmlFor="paymentMode" className="col-form-label">
                                                          Advance DMR
                                                        </label>
                                                      </Col>
                          
                                                      <Col lg="2">
                                                    <Select
                                      options={advanceOptions}
                                      onChange={evnt => this.setState({F_AdvanceId : evnt.value})}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          height: "auto", // Ensure container height adjusts automatically
                                          overflowY: "auto", // Allow vertical scrolling if content overflows
                                          whiteSpace: "normal", // Allow text to wrap
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          whiteSpace: "normal", // Allow text to wrap within single value container
                                          overflow: "hidden", // Hide any overflow
                                          textOverflow: "ellipsis", // Add ellipsis for overflow text
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          position: "absolute",
                                          zIndex: 9999,
                                          top: "100%", // Position below the input field
                                          maxHeight: "200px", // Adjust as needed for maximum height
                                          overflowY: "auto", // Allow vertical scrolling in the dropdown
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      value={defaultAdvanceAOption}
                                      menuPortalTarget={document.body}
                                    />
                          
                                    </Col>
                                    
                                    </> 
                                                    :null}



{this.state.selectedPaymentMode == 3?
                          
                          <>
                                                    <Col sm="2" className="mb-3">
                                                        <label htmlFor="paymentMode" className="col-form-label">
                                                          Select DMR Transaction
                                                        </label>
                                                      </Col>
                          
                                                      <Col lg="2">
                                                    <Select
                                      options={refundedOptions}
                                      onChange={evnt => this.setState({F_RefundedDMR : evnt.value})}
                                      styles={{
                                        container: (provided) => ({
                                          ...provided,
                                          height: "auto", // Ensure container height adjusts automatically
                                          overflowY: "auto", // Allow vertical scrolling if content overflows
                                          whiteSpace: "normal", // Allow text to wrap
                                        }),
                                        singleValue: (provided) => ({
                                          ...provided,
                                          whiteSpace: "normal", // Allow text to wrap within single value container
                                          overflow: "hidden", // Hide any overflow
                                          textOverflow: "ellipsis", // Add ellipsis for overflow text
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          position: "absolute",
                                          zIndex: 9999,
                                          top: "100%", // Position below the input field
                                          maxHeight: "200px", // Adjust as needed for maximum height
                                          overflowY: "auto", // Allow vertical scrolling in the dropdown
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      value={defaultRefundedOption}
                                      menuPortalTarget={document.body}
                                    />
                          
                                    </Col>
                                    
                                    </> 
                                                    :null}



                          </Row>
                         

      
                          {/* Main Data Table */}
                         
                        </Col>
      
                        {/* Right Column: Denominations */}
                        <Row>
                        <Col lg="6">
                          {showDenomination && (
                            <>
                            <h5>Denomination</h5>
                              <Table striped bordered responsive className="table-sm">
                                <thead>
                                  <tr>
                                    <th>Denomination</th>
                                    <th>Quantity</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {denominations.map((Denomination, index) => (
                                    <tr key={index}>
                                      <td>{Denomination.Denomination === 1 ? "Coin" : Denomination.Denomination} x</td>
                                      <td>
                                        <input
                                          type="number"
                                          min={0}
                                          value={Denomination.Quantity}
                                          className="form-control form-control-sm"
                                          onFocus={event => event.target.select()}
                                          onChange={e => this.handleQuantityChange(e, index)}
                                        />
                                      </td>

                                      <td>{Denomination.Denomination * Denomination.Quantity}</td>

                                    </tr>

                                  ))}
                                </tbody>

                              </Table>
      
                              <Row className="mt-3">
                                <Col sm="6">
                                  <label htmlFor="DenominationAmount" className="col-form-label">
                                    Denomination Total
                                  </label>
                                </Col>
                                <Col sm="6">
                                  <Input
                                    min="0" 
                                    type="text"
                                    name="DenominationAmount"
                                    value={this.state.DenominationAmount || 0}
                                    disabled
                                    className="form-control form-control-sm"
                                  />
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                            <Col lg="6"> {isRe && (
                            <>
                              <Row>
                                <Col lg="12">
                                  <h5>Denomination Return  {this.state.RemainingAmt}</h5>
                                  <Table striped bordered responsive className="table-sm">
                                    <thead>
                                      <tr>
                                        <th>Denomination</th>
                                        <th>Quantity</th>
                                        <th>Total</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {denominationsRe.map((Denomination, index) => (
                                        <tr key={index}>
                                          <td>{Denomination.Denomination === 1 ? "Coin" : Denomination.Denomination} x</td>
                                          <td>
                                            <input
                                              type="number"
                                              min={0}
                                              value={Denomination.Quantity}
                                              className="form-control form-control-sm"
                                              onFocus={event => event.target.select()}
                                              onChange={e => this.handleDenominationReChange(e, index)}
                                            />
                                          </td>
                                          <td>{Denomination.Denomination * Denomination.Quantity}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row>

                              <Row className="mt-3">
                                <Col sm="6">
                                  <label htmlFor="DenominationReAmount" className="col-form-label">
                                    DenominationRe Total
                                  </label>
                                </Col>
                                <Col sm="6">
                                  <Input
                                    min="0" 
                                    type="text"
                                    name="DenominationReAmount"
                                    value={this.calculateDenominationReTotal() || 0}
                                    disabled
                                    className="form-control form-control-sm"
                                  />
                                </Col>
                              </Row>
                            </>
                          )}</Col>
                        </Row>
                       
                       
                      </Row>

                      <Row>
                              <Col lg={12}>
                                <Card>
                                  <CardBody>
                                    <Offcanvas
                                      isOpen={this.state.isRight}
                                      direction="end"
                                      toggle={this.toggleRightCanvas}
                                    >
                                      <OffcanvasHeader
                                        toggle={this.toggleRightCanvas}
                                      >
                                        Fund Request
                                      </OffcanvasHeader>
                                      <OffcanvasBody>
                                      <PageAddEdit_FundrequestN Amount={this.state.UPIAmount}/>

                                   
                                      </OffcanvasBody>
                                    </Offcanvas>

                                  

                        
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          
                      {/* Save and Go Back Buttons */}
                      <Row className="mt-3">
                        {/* <Col sm="12" className="text-right">
                          <Button type="submit" color="primary" className="btn-sm mr-2">
                            Save
                          </Button>
                          <Button
                            type="button"
                            color="secondary"
                            className="btn-sm"
                            onClick={this.btnGoBack_onClick}
                          >
                            Go Back
                          </Button>
                        </Col> */}
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      
        {/* Custom CSS */}
        <style jsx>{`
          .no-scroll-container {
            height: 100vh; /* Use full viewport height */
            overflow: hidden; /* Prevent scrolling */
          }
      
          .no-scroll-card {
            max-height: calc(100vh - 150px); /* Adjust height for breadcrumbs and header */
            overflow: auto; /* Scroll within the card */
          }
      
          .no-scroll-card-body {
            padding: 10px; /* Minimize padding for compact layout */
          }
      
          .table-sm td,
          .table-sm th {
            padding: 0.25rem; /* Smaller padding for table rows */
            border: 1px solid #000; /* Set border color and width */
          }
          
          /* Add background color to header */
          .table-sm thead th {
            background-color: #007bff; /* Change this to your preferred header color */
            color: white; /* Set text color for header */
          }
          
          /* Alternate row colors */
          .table-row:nth-child(odd) {
            background-color: #f2f2f2; /* Light gray for odd rows */
          }
          
          .table-row:nth-child(even) {
            background-color: white; /* White for even rows */
          }
            
          .form-control-sm {
            font-size: 0.875rem; /* Reduce font size for inputs */
          }
      
          .btn-sm {
            padding: 0.25rem 0.5rem; /* Smaller buttons */
            font-size: 0.875rem;
          }
          
          /* Added styles for better border visibility */
          .table-sm {
            border-collapse: collapse; /* Ensure borders are collapsed for a clean look */
          }
          
          .table-sm th,
          .table-sm td {
            border: 1px solid #dee2e6; /* Bootstrap default border color */
          }
  
        `}</style>
      </React.Fragment>
      
    );
  }

  handleDenominationReChange(event, index) {
    const value = Number(event.target.value);
    const denominationsRe = [...this.state.denominationsRe];
    denominationsRe[index].Quantity = value;
    this.setState({ denominationsRe }, this.calculateDenominationReTotal);
  }

  calculateDenominationReTotal() {
    const { denominationsRe } = this.state;
    let total = 0;
    denominationsRe.forEach(({ Denomination, Quantity }) => {
      total += Denomination * Quantity; // Calculate total for DenominationRe
    });
    return total;
  }
}

export default compose(container)(AddEdit_ChargesEntry);